import "./fluxoPeguntas.css";
import HeaderProtected from "../../componentes/headerProtected/header";
import ConfigSteps from "../../componentes/fluxo-nsimilar/ConfigSteps";
import Sidebar from "../../componentes/sideBar/SideBar";
import { SupportFooter } from "../../componentes/supportFooter/supportFooter";
const FluxoPerguntas = () => {
  return (
    <>
      <Sidebar />
      <HeaderProtected />
      <div className="pageWrapper">
        <div className="containerFluxoPerguntas">
          <ConfigSteps />
        </div>

        <SupportFooter />
      </div>
    </>
  );
};

export default FluxoPerguntas;
